(() => {
  const notice = document.querySelector('[data-cart-notice]');
  if (!notice) return;

  const titleLabel = notice.querySelector('strong');
  const productLabel = notice.querySelector('[data-cart-notice-product]');
  let hideTimer;

  const storefrontRoot = () => window.Shopify?.routes?.root || '/';
  const numericValue = (value, fallback = 0) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  };
  const requestedVariantIds = (form) => [...form.querySelectorAll('input[name="id"], input[name$="[id]"]')]
    .map((input) => numericValue(input.value))
    .filter((variantId) => variantId > 0);
  const cartQuantityForVariant = (cart, variantId) => (cart?.items || []).reduce((total, item) => (
    Number(item.variant_id) === variantId ? total + Number(item.quantity || 0) : total
  ), 0);

  const setCartCount = (count) => {
    document.querySelectorAll('.info-header__cart').forEach((cartLink) => {
      let badge = cartLink.querySelector('.info-header__cart-count');
      if (count < 1) {
        badge?.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'info-header__cart-count';
        cartLink.appendChild(badge);
      }
      badge.textContent = String(count);
      badge.hidden = false;
    });
  };

  const hideNotice = () => {
    notice.classList.remove('is-visible');
    notice.setAttribute('aria-hidden', 'true');
  };

  const showNotice = (title, message) => {
    titleLabel.textContent = title;
    productLabel.textContent = message;
    notice.classList.add('is-visible');
    notice.setAttribute('aria-hidden', 'false');
    clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hideNotice, 6500);
  };

  const updateInventoryControls = (cart, rejectedVariantIds = []) => {
    document.querySelectorAll('[data-inventory-control]').forEach((button) => {
      const variantId = numericValue(button.dataset.variantId);
      const available = button.dataset.available === 'true';
      const inventoryLimited = button.dataset.inventoryLimited === 'true';
      const minimum = Math.max(1, numericValue(button.dataset.quantityMin, 1));
      const cartQuantity = cartQuantityForVariant(cart, variantId);
      const remaining = numericValue(button.dataset.inventoryQuantity) - cartQuantity;
      const ruleMaximum = button.dataset.quantityRuleMax === ''
        ? null
        : numericValue(button.dataset.quantityRuleMax, null);
      const rejected = rejectedVariantIds.includes(variantId);
      const canAdd = available
        && !rejected
        && (!inventoryLimited || remaining >= minimum)
        && (ruleMaximum === null || ruleMaximum - cartQuantity >= minimum);
      const label = button.querySelector('[data-inventory-control-label]');
      const cardStock = button.closest('[data-product-card]')?.querySelector('[data-card-stock]');
      const controlLabel = rejected
        ? notice.dataset.stockChanged
        : (!available ? button.dataset.unavailableLabel : (canAdd ? button.dataset.addLabel : button.dataset.limitLabel));

      button.disabled = !canAdd;
      button.setAttribute('aria-disabled', String(!canAdd));
      if (label) label.textContent = controlLabel;
      if (cardStock && !canAdd) {
        cardStock.textContent = controlLabel;
        cardStock.classList.add('is-unavailable');
      }
    });
  };

  notice.querySelectorAll('[data-cart-notice-close]').forEach((button) => button.addEventListener('click', hideNotice));

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || event.submitter?.name === 'checkout') return;

    event.preventDefault();
    const button = event.submitter;
    const originalHtml = button?.innerHTML;
    const wasDisabled = button?.disabled || false;
    const variantIds = requestedVariantIds(form);
    let cart = null;
    let rejectedIds = [];

    if (button) {
      button.disabled = true;
      const loadingLabel = button.querySelector('[data-inventory-control-label]');
      if (loadingLabel) loadingLabel.textContent = notice.dataset.loadingMessage;
      else button.textContent = notice.dataset.loadingMessage;
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: new FormData(form)
      });
      const payload = await response.clone().json().catch(() => null);
      if (!response.ok) {
        const requestError = new Error(payload?.description || payload?.message || notice.dataset.errorMessage);
        requestError.status = response.status;
        throw requestError;
      }

      const card = form.closest('[data-product-card]');
      const page = form.closest('.info-product-page');
      const productTitle = card?.querySelector('.info-product-card__title')?.textContent?.trim()
        || page?.querySelector('h1')?.textContent?.trim()
        || notice.dataset.successMessage;
      showNotice(notice.dataset.successTitle, productTitle);
    } catch (error) {
      const stockError = error.status === 422;
      if (stockError) rejectedIds = variantIds;
      showNotice(
        notice.dataset.errorTitle,
        stockError ? notice.dataset.stockError : (error.message || notice.dataset.errorMessage)
      );
    } finally {
      try {
        const cartResponse = await fetch(`${storefrontRoot()}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        cart = await cartResponse.json();
      } catch (cartError) {
        console.error('Erro ao atualizar o estado do carrinho:', cartError);
      }

      if (button) button.innerHTML = originalHtml;
      if (cart) {
        setCartCount(cart.item_count);
        updateInventoryControls(cart, rejectedIds);
        document.dispatchEvent(new CustomEvent('shopify:cart:updated', {
          bubbles: true,
          detail: { cart, rejectedVariantIds: rejectedIds }
        }));
      } else if (button) {
        button.disabled = wasDisabled;
      }
    }
  });
})();
